import styles from '../styles/bim.module.scss';
import { useContext, useState, useEffect, useRef } from 'react';
import { Context } from '../Context';

import DataTable from 'react-data-table-component';
// import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';
import { useTranslation } from 'react-i18next';
import SvgCell from './SvgCell';
import Select from 'react-select';

// media
import { ReactComponent as ListIcon } from '../media/img/List.svg';
import { ReactComponent as GridIcon } from '../media/img/Grid.svg';
import { ReactComponent as IconSale } from '../media/img/icon-sale.svg';
import { ReactComponent as IconHeartEmpty } from '../components/ApartmentView/assets/icons/icon-heart.svg';
import { ReactComponent as IconHeartFilled } from '../components/ApartmentView/assets/icons/icon-heart-filled.svg';

import { AVAILABILITY_STATUS } from '../constants/availabilityStatus';
import { MOBILE_VIEW_TYPES } from '../constants/mobileViewTypes';
import { LAYER_TYPES } from '../constants/layerTypes';
const { AVAILABLE, SOLD, RESERVED, UNKNOWN } = AVAILABILITY_STATUS;
const { APARTMENT_VIEW } = MOBILE_VIEW_TYPES;

function ApartmentsView() {
	const {
		isMobile,
		isDesktop,
		 displayableApartmentsData,
		activeApartment,
		setActiveApartment,
		setActiveApartmentHandle,
		showView,
		setShowView,
		setMobileActiveView,
		mobileActiveView,
		filteredApartmentData,
		setFilteredApartmentData,
		setActiveLayer,
		buildingsData,
		isFilterActive,
		overviewLayerRef,
		arePricesVisible,
		layoutList,
		setLayoutList,
		setIsFilterActive,
		projectSetup,
		projectStyle,
		toggleFavoriteApartmentHandler,
		applySortingHandler,
		sortingConfig,
		filteredApartmentsCount,
		apartmentsToDisplayData,
    displayableApartmentsCount,
	} = useContext(Context);

	const tableContainerRef = useRef(null);


	const [currentPage, setCurrentPage] = useState(1);
	const itemsPerPage = 12;
	const totalItems = filteredApartmentsCount;
	// const totalItems = filteredApartmentData.length;

	const has_multi_buildings = buildingsData.length > 1;
	const hasMultipleGates =
		new Set( displayableApartmentsData.map((apartment) => apartment.gate)).size > 1;

	const totalPages = Math.ceil(totalItems / itemsPerPage);

	const areSoldAccessible =
		projectSetup.website.are_sold_apartments_accessible || false;

	const { t } = useTranslation();

	const handleSort = (column, sortDirection) => {
		applySortingHandler({ key: column.sortField, direction: sortDirection });
		// setSortConfig({ key: column.sortField, direction: sortDirection });
	};

	const handlePageClick = (pageNumber) => {
		setCurrentPage(pageNumber);
	};

	const renderPagination = () => {
		const pageNumbers = [];
		for (let i = 1; i <= totalPages; i++) {
			pageNumbers.push(
				<button
					key={i}
					onClick={() => handlePageClick(i)}
					className={i === currentPage ? 'active' : ''}
				>
					{i}
				</button>
			);
		}
		return <div className="pagination">{pageNumbers}</div>;
	};

	
	const availabilityLabel = (row) => {
		switch (row.availability) {
			case SOLD:
				return (
					<span className={`${styles.cell_data} state-sell`}>{t('sold')}</span>
				);
			case RESERVED:
				return (
					<span className={`${styles.cell_data} state-reserved`}>
						{t('reserved')}
					</span>
				);
			case AVAILABLE:
				return (
					<span className={`${styles.cell_data} state-available`}>
						{t('available')}
					</span>
				);
			case UNKNOWN:
				return <span className={styles.cell_data}>{t('no_data')}</span>;
			default:
				return <span className={styles.cell_data}>{t('no_data')}</span>;
		}
	};

	const columns = [
		{
			name: t('number'),
			id: 'number',
			selector: (row) => row.id_cad,
			sortField: 'id_cad',
			sortable: true,
			cell: (row) => (
				<div className="number-cell">
					<span className={styles.cell_title}>{t('number')}:</span>
					<span className={styles.cell_data}>
						{!layoutList ? `${t('unit')} - ` : null} {row.id_original}
					</span>
				</div>
			),
			maxWidth: '8rem',
		},
		{
			name: t('tier'),
			id: 'tier',
			omit: layoutList && isMobile,
			selector: (row) => row.ref_tier,
			sortField: 'ref_tier',
			// id: "ref_tier",
			sortable: true,
			cell: (row) => (
				<div className="tier-cell">
					<span className={styles.cell_title}>{t('tier')}:</span>{' '}
					<span className={styles.cell_data}>{row.ref_tier}</span>
				</div>
			),
			maxWidth: '8rem',
		},
		{
			name: t('rooms'),
			id: 'rooms',
			selector: (row) => row.rooms,
			sortField: 'rooms',
			sortable: true,
			cell: (row) => (
				<div className="rooms-cell">
					<span className={styles.cell_title}>{t('rooms')}:</span>{' '}
					<span className={styles.cell_data}>{row.rooms}</span>
				</div>
			),
			maxWidth: '8rem',
		},
		{
			name: t('surface'),
			id: 'area',
			selector: (row) => row.area_original,
			sortField: 'area_original',
			sortable: true,
			cell: (row) => (
				<div className="surface-cell">
					<span className={styles.cell_title}>{t('surface')}:</span>{' '}
					<span className={styles.cell_data}>
						{row.area_original}m<sup>2</sup>
					</span>
				</div>
			),
			maxWidth: '8rem',
		},
		{
			name: t('availability'),
			id: 'availability',
			selector: (row) => row.availability,
			sortField: 'availability',
			sortable: true,
			cell: (row) => (
				<div className="availability-cell">
					<span className={styles.cell_title}>{t('availability')}:</span>{' '}
					{availabilityLabel(row)}
				</div>
			),
			maxWidth: '10rem',
		},
		{
			name: t('favorites'),
			id: 'favorites',
			selector: (row) => row.isFavorite,
			sortField: 'isFavorite',
			sortable: true,
			cell: (row) => (
				<div className="favorites-cell">
					<span className={styles.cell_title}>{t('favorites')}:</span>
					<button
						className={styles.list_favorite_icon}
						disabled={!areSoldAccessible && row.availability === SOLD}
						onClick={(e) => {
							e.stopPropagation();
							if (e.nativeEvent) e.nativeEvent.stopImmediatePropagation();
							toggleFavoriteApartmentHandler(row.uuid);
						}}
					>
						{row.isFavorite ? <IconHeartFilled /> : <IconHeartEmpty />}
					</button>
				</div>
			),
			maxWidth: '8rem',
		},
		{
			name: t('apartment_card'),
			id: 'button',
			omit: isMobile && layoutList,
			cell: (row) => (
				<button
					className={`${styles.apartment_card_btn}`}
					disabled={!areSoldAccessible && row.availability === SOLD}
					onClick={(e) => {
						e.stopPropagation();
						if (e.nativeEvent) e.nativeEvent.stopImmediatePropagation();
						setActiveApartmentHandle(row.id_original);
						if (isMobile) {
							setMobileActiveView(APARTMENT_VIEW);
						}
					}}
				>
					{t('see_apartment')}
				</button>
			),
			// maxWidth: '9rem',
		},
	];

	if (hasMultipleGates) {
		columns.unshift({
			name: t('gate'),
			id: 'gate',
			selector: (row) => row.gate,
			sortField: 'gate',
			// omit: !layoutList && isMobile,
			sortable: true,
			cell: (row) => (
				<div className="gate-cell">
					<span className={styles.cell_title}>{t('gate')}:</span>{' '}
					<span className={styles.cell_data}>{row.gate}</span>
				</div>
			),
			maxWidth: '8rem',
		});
	}

	if (has_multi_buildings) {
		columns.unshift({
			name: t('building'),
			id: 'building',
			selector: (row) => row.edifice_name,
			sortField: 'edifice_name',
			sortable: true,
			cell: (row) => (
				<div className="gate-cell">
					<span className={styles.cell_title}>{t('building')}:</span>{' '}
					<span className={styles.cell_data}>{row.edifice_name}</span>
				</div>
			),
		});
	}

	if (arePricesVisible) {
		const priceColumn = {
			name: t('price'),
			id: 'price',
			selector: (row) => parseFloat(row.price_brutto),
			sortField: 'price_brutto',
			sortable: true,
			minWidth: '10rem',
			cell: (row) => {
				const priceValue = parseFloat(row.price_brutto);
				// const isApartmentSold = row.availability === SOLD;
				const isApartmentPriceHidden = !row.price_visibility;
				// const formattedPrice = isApartmentSold
				const formattedPrice = isApartmentPriceHidden
					? t('ask_for_price')
						: !isNaN(priceValue)
							? priceValue.toLocaleString('pl-PL', {
								style: 'currency',
								currency: 'PLN',
								minimumFractionDigits: 2,
								maximumFractionDigits: 2,
					  	})
							: t('no_data');
				return (
					<div className="price-cell">
						<span className={styles.cell_title}>{t('price')}:</span>
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								alignItems: 'center',
								justifyContent: 'space-between',
								gap: '1rem',
							}}
						>
							{row.price_offer?.on_offer && !isApartmentPriceHidden && (
                <div 
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <IconSale 
                    style={{ 
                      color: 'var(--color-secondary)', 
                      width: '2rem', 
                      height: '2rem' 
                    }} 
                  />
                </div>
							)}
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
                  alignItems: 'flex-start',
								}}
							>
								{row.price_history?.length > 1 && !isApartmentPriceHidden && (
									<span
										style={{
											fontSize: '0.75rem',
											textDecoration: 'line-through',
											color: 'var(--color-label)',
										}}
									>
										{parseFloat(row.price_history[0].price_brutto).toLocaleString('pl-PL', {
											style: 'currency',
											currency: 'PLN',
											minimumFractionDigits: 2,
											maximumFractionDigits: 2,
										})}
									</span>
								)}
								<span className={styles.cell_data}>{formattedPrice}</span>
							</div>
						</div>
					</div>
				);
			},
		};

		const insertIndex = columns.length > 0 ? columns.length - 1 : 0;
		columns.splice(insertIndex, 0, priceColumn);
	}

	if (!layoutList) {
		columns.unshift({
			name: 'svg',
			id: 'svg',
			omit: layoutList,
			cell: (row) => (
				<SvgCell key={row.uuid} row={row} layoutList={layoutList} />
			),
		});
	}

	const conditionalRowStyles = [
		{
			when: (row) => row.id_original === activeApartment,
			style: {
				border: '3px solid var(--color-primary) !important',
				borderBottom: '3px solid var(--color-primary) !important',
			},
		},
		// {
		//   when: row => row.availability == RESERVED,
		//   style: {
		//     backgroundColor: 'rgba(0, 0, 0, 0.1) !important',
		//   },
		// },
		{
			when: (row) => row.availability == SOLD,
			style: {
				opacity: '0.6 !important',
				pointerEvents: 'none !important',
				boxShadow: 'none !important',
				// cursor: 'default !important',
			},
		},
	];

       const sortableColumns = columns.filter((c) => c.sortable && c.sortField);

       // Opcje dla Select
       const sortKeyOptions = sortableColumns.map((col) => ({
	       value: col.sortField,
	       label: col.name,
       }));
       const sortDirectionOptions = [
	       { value: 'asc', label: t('ascending') },
	       { value: 'desc', label: t('descending') },
       ];
       // Wybrane wartości jako obiekty
       const selectedSortKey = sortKeyOptions.find(opt => opt.value === sortingConfig.key) || sortKeyOptions[0];
       const selectedSortDirection = sortDirectionOptions.find(opt => opt.value === sortingConfig.direction) || sortDirectionOptions[0];

	useEffect(() => {
		if (activeApartment && isDesktop && tableContainerRef.current) {
			const scrollToActiveApartment = () => {
				const activeIndex = apartmentsToDisplayData.findIndex(
					(apartment) => apartment.id_original === activeApartment
				);

				if (activeIndex !== -1) {
					// Znajdź styled-components kontener z overflow
					const scrollContainer =
						tableContainerRef.current.querySelector('div[class^="sc-"]');

					if (
						scrollContainer &&
						scrollContainer.scrollHeight > scrollContainer.clientHeight
					) {
						const rows = scrollContainer.querySelectorAll('.rdt_TableRow');
						const activeRow = rows[activeIndex];

						if (activeRow) {
							// Scroll do środka kontenera
							const containerRect = scrollContainer.getBoundingClientRect();
							const rowRect = activeRow.getBoundingClientRect();
							const scrollTop = scrollContainer.scrollTop;
							const targetScrollTop =
								scrollTop +
								(rowRect.top - containerRect.top) -
								containerRect.height / 2 +
								rowRect.height / 2;

							scrollContainer.scrollTo({
								top: targetScrollTop,
								behavior: 'smooth',
							});
						}
					}
				}
			};

			const timeoutId = setTimeout(scrollToActiveApartment, 200);
			return () => clearTimeout(timeoutId);
		}
	}, [activeApartment, apartmentsToDisplayData, isDesktop]);

	const getSelectStyles = () => ({
		control: (baseStyles, state) => ({
			...baseStyles,
			minHeight: '2.5rem',
			minWidth: '12rem',
			backgroundColor: 'var(--color-offwhite)',
			borderColor: state.isFocused ? 'var(--color-secondary)' : 'hsl(0, 0%, 80%)',
			borderRadius: '0px',
			boxShadow: state.isFocused ? '0 0 0 1px var(--color-secondary)' : 'none',
			'&:hover': {
				borderColor: 'var(--color-secondary)',
			},
		}),
		option: (baseStyles, state) => ({
			...baseStyles,
			fontSize: '0.9rem',
			padding: '0.4rem 0.75rem',
			backgroundColor: state.isSelected
				? 'var(--color-secondary)'
				: state.isFocused
				? '#' + projectStyle.__color_secondary + '60'
				: 'transparent',
		}),
	});


	return (
		<div className={styles.apartments_view}>
		
			<div
				className={`${styles.apartment_table} ${
					layoutList ? styles.list_layout : styles.grid_layout
				}`}
				>
				{
					// isMobile &&
					// !layoutList && (
					// <div className={styles.grid_layout_nav_bar}>
					<div className={styles.sort_list_top_bar}>
						<div className={styles.sort_dropdown_container} style={{zIndex: 400}}>
							{/* <label htmlFor="sort-select"> */}
								<h3 className={styles.sort_heading}>{t('sort_by')}:</h3>
							{/* </label> */}
							   <Select
								   id="sort-select"
								   value={selectedSortKey}
								   onChange={(option) =>
									   applySortingHandler({ ...sortingConfig, key: option.value })
								   }
								   options={sortKeyOptions}
								   styles={getSelectStyles()}
							   />
							   <Select
								   id="sort-direction"
								   value={selectedSortDirection}
								   onChange={(option) =>
									   applySortingHandler({ ...sortingConfig, direction: option.value })
								   }
								   options={sortDirectionOptions}
								   styles={getSelectStyles()}
							   />
						</div>
						<div className={styles.layout_nav}>
							<ListIcon
								onClick={() => {
									setLayoutList(true);
								}}
								className={`${styles.list_icon} ${layoutList ? 'active' : ''}`}
							/>
							<GridIcon
								onClick={() => {
									setLayoutList(false);
								}}
								className={`${styles.grid_icon} ${!layoutList ? 'active' : ''}`}
							/>
						</div>
					</div>
					// )
				}
				<div ref={tableContainerRef} className={styles.data_table_container}>
					<DataTable
						key={activeApartment}
						columns={columns}
						// data={filteredApartmentData}
						// data={sortedData}
						data={apartmentsToDisplayData}
						onSort={handleSort}
						sortServer
						fixedHeader={true}
						fixedHeaderScrollHeight="75vh"
						pagination={isMobile}
						paginationPerPage={12}
						paginationDefaultPage={currentPage}
						onChangePage={(currentPage) => setCurrentPage(currentPage)}
						noDataComponent={
							<div className={styles.no_data}>{t('no_apartments_found')}</div>
						}
						conditionalRowStyles={conditionalRowStyles}
						onRowClicked={
							isMobile
								? (row) => {
										setActiveApartmentHandle(row.id_original);
										if (isMobile) {
											// window.scrollTo({ top: 0, behavior: 'smooth' });
											setMobileActiveView(APARTMENT_VIEW);
										}
								  }
								: undefined
						}
					/>
				</div>
				{isMobile && (
					<div className={styles.apartments_list_navigation}>
						{renderPagination()}
					</div>
				)}

			</div>
		</div>
	);
}

export default ApartmentsView;